import React, { Component } from "react";
import { withAuth } from "../Auth/WithAuth";
import AddUserModal from "./AddUserModal";
import MoveUserModal from "./MoveUserModal";
import { authenticatedFetch } from "../../utils/apiClient";

let isMounted = false;

export default withAuth(
  class SignupList extends Component {
    constructor(props) {
      super(props);
      this.state = {
        persons: {},
        editMode: false,
        printNotes: false,
        printList: false,
        showAddUserModal: false,
        showMoveUserModal: false,
        selectedUserForMove: null,
        updated: Date().toLocaleString()
      };
      this.handlePaid = this.handlePaid.bind(this);
      this.setPaid = this.setPaid.bind(this);
      this.setUnPaid = this.setUnPaid.bind(this);
      this.setArrived = this.setArrived.bind(this);
      this.setUnArrived = this.setUnArrived.bind(this);
      this.getPersons = this.getPersons.bind(this);
      this.deleteUser = this.deleteUser.bind(this);
      this.setEditMode = this.setEditMode.bind(this);
      this.seatNotes = this.seatNotes.bind(this);
      this.seatList = this.seatList.bind(this);
      this.addUser = this.addUser.bind(this);
      this.timeStampHandler = this.timeStampHandler.bind(this);
      this.openMoveModal = this.openMoveModal.bind(this);
      this.closeMoveModal = this.closeMoveModal.bind(this);
      this.onMoveSuccess = this.onMoveSuccess.bind(this);
    }

    async componentDidMount() {
      isMounted = true;
      this.getPersons();
    }

    componentDidUpdate() {
      // Authentication is now handled by WithAuth HOC
    }

    componentWillUnmount() {
      isMounted = false;
      clearInterval(this.interval);
    }

    async getPersons() {
      // Check if user is authenticated via props from WithAuth HOC
      if (!this.props.authenticated) {
        console.log("User not authenticated");
        this.props.auth.logout();
        return;
      }

      try {
        authenticatedFetch("/api/admin/getpersons", {
          method: "get",
          headers: {
            Accept: "application/json",
            pragma: "no-cache",
            "cache-control": "no-cache"
          }
        })
          .then(response => {
            return response.json();
          })
          .then(persondata => {
            this.setState({ persons: persondata });
            this.setState({ updated: Date().slice(16, 24) });
          })
          .catch(err => {
            return('error fetching persons1');
          });
      } catch (err) {
        console.log(err);
        return('error fetching persons2');
      }
    }

    async setPaid(person) {
      try {
        authenticatedFetch("/api/admin/setpaid", {
          method: "PUT",
          body: JSON.stringify(person),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
      } catch (err) {
        console.log(err);
      }
    }

    async setArrived(person) {
      try {
        authenticatedFetch("/api/admin/setarrived", {
          method: "PUT",
          body: JSON.stringify(person),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
      } catch (err) {
        console.log(err);
      }
    }

    async setUnPaid(person) {
      try {
        authenticatedFetch("/api/admin/setunpaid", {
          method: "PUT",
          body: JSON.stringify(person),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
      } catch (err) {
        console.log(err);
      }
    }

    async setUnArrived(person) {
      try {
        authenticatedFetch("/api/admin/setunarrived", {
          method: "PUT",
          body: JSON.stringify(person),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
      } catch (err) {
        console.log(err);
      }
    }

    async addUser() {
      if (this.state.showAddUserModal === false) {
        this.setState({ showAddUserModal: true });
      } else {
        this.setState({ showAddUserModal: false });
      }
    }

    async deleteUser(e) {
      let person = e;
      let data = {};
      data.code = person.code;
      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";
      data.UpdatedBy = updatedBy;
      data.firstName = person.firstName;
      data.lastName = person.lastName;
      data.phone = person.phone;
      data.paid = person.paid;
      data.arrived = person.arrived;
      data.rowNum = person.rowNum;
      data.seatNum = person.seatNum;

      data.text = prompt(
        "Hva er grunnen til at du sletter denne brukeren?",
        ""
      );
      if (data.text === null) {
        return;
      } else if (data.text.length < 1) {
        this.deleteUser(e);
        return;
      }
      if (
        window.confirm(
          "Er du sikker på at du vil slette " +
            person.firstName +
            " " +
            person.lastName +
            "?"
        )
      ) {
        //Continue
      } else {
        return;
      }
      let confirmCode = prompt("Fyll inn " + data.code + " for å slette", "");

      if (confirmCode !== data.code) {
        this.deleteUser(e);
        return;
      }

      try {
        await authenticatedFetch("/api/admin/deleteuser/" + person.code, {
          method: "PUT",
          body: JSON.stringify(data),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        });
      } catch (err) {
        console.log(err);
      }
      setTimeout(() => {
        this.getPersons();
      }, 300);
    }

    async handlePaid(person) {
      if (this.state.editMode === false) {
        return;
      }

      let timesRun = 0;
      let interval = setInterval(() => {
        timesRun += 1;
        if (timesRun === 3) {
          clearInterval(interval);
        }
        this.getPersons();
      }, 1000);

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";
      person.UpdatedBy = updatedBy;

      if (person.paid === false) {
        await this.setPaid(person);
        this.getPersons();
      } else if (person.paid === true) {
        await this.setUnPaid(person);
        this.getPersons();
      }
    }

    async handleArrived(person) {
      if (this.state.editMode === false) {
        return;
      }

      let timesRun = 0;
      let interval = setInterval(() => {
        timesRun += 1;
        if (timesRun === 3) {
          clearInterval(interval);
        }
        this.getPersons();
      }, 1000);

      let updatedBy = this.props.auth.currentUser ? this.props.auth.currentUser.username : "Unknown";
      person.UpdatedBy = updatedBy;

      if (person.arrived === false) {
        await this.setArrived(person);
        this.getPersons();
      } else if (person.arrived === true) {
        await this.setUnArrived(person);
        this.getPersons();
      }
    }

    async setEditMode() {
      if (this.state.editMode === false) {
        this.setState({ editMode: true });
      } else {
        this.setState({ editMode: false });
      }
      await this.getPersons();
    }

    async seatNotes() {
      await this.setState({ printNotes: true });
      window.print();
      await this.setState({ printNotes: false });
    }

    async seatList() {
      await this.setState({ printList: true });
      window.print();
      await this.setState({ printList: false });
    }

    timeStampHandler(timestamp) {
      try {
        if (timestamp !== undefined) {
          const time = parseInt(timestamp);
          const date = new Date(time);

          const dateString =
            ("0" + date.getDate()).slice(-2) +
            "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) +
            "-" +
            date.getFullYear();

          return dateString;
        } else {
          return "";
        }
      } catch (e) {
        return "";
      }
    }

    openMoveModal(person) {
      this.setState({
        showMoveUserModal: true,
        selectedUserForMove: person
      });
    }

    closeMoveModal() {
      this.setState({
        showMoveUserModal: false,
        selectedUserForMove: null
      });
    }

    onMoveSuccess() {
      // Refresh the persons list after successful move
      this.getPersons();
      this.setState({ updated: Date().toLocaleString() });
    }

    render() {
      if (this.props.authenticated === null) return null;
      const personRows = [];
      let paid = 0;
      let food = 0;
      let arrived = 0;
      for (let i = 0; i < this.state.persons.length; i++) {
        let person = this.state.persons[i];
        personRows.push(
          <tr key={i}>
            <td>{this.state.persons[i].code}</td>
            <td>{this.timeStampHandler(this.state.persons[i].timestamp)}</td>
            <td>
              <label className="container">
                <h5 className="printBox">
                  {this.state.persons[i].paid ? "Ja" : "Nei"}
                </h5>
                <input
                  type="checkbox"
                  checked={this.state.persons[i].paid}
                  onChange={() => this.handlePaid(person)}
                  value={this.state.persons[i]}
                />
                <span
                  className={
                    "checkmark " +
                    (this.state.editMode ? "enabled" : "disabled")
                  }
                ></span>
              </label>
            </td>
            <td>
              <label className="container">
                <h5 className="printBox">
                  {this.state.persons[i].arrived ? "Ja" : "Nei"}
                </h5>
                <input
                  type="checkbox"
                  checked={this.state.persons[i].arrived}
                  onChange={() => this.handleArrived(person)}
                  value={this.state.persons[i]}
                />
                <span
                  className={
                    "checkmark " +
                    (this.state.editMode ? "enabled" : "disabled")
                  }
                ></span>
              </label>
            </td>
            <td>{this.state.persons[i].rowNum}</td>
            <td>{this.state.persons[i].seatNum} </td>
            <td>{this.state.persons[i].firstName}</td>
            <td> {this.state.persons[i].lastName}</td>
            <td> {this.state.persons[i].email}</td>
            <td> {this.state.persons[i].age}</td>
            <td> {this.state.persons[i].foodTicket.toString()}</td>
            <td> {this.state.persons[i].phone}</td>
            <td>
              <button
                className="btn btn-warning help printHide"
                style={{ marginRight: "5px" }}
                onClick={() => this.openMoveModal(person)}
                title="Flytt bruker"
              >
                ↔
              </button>
              <button
                className="btn btn-danger help printHide"
                value={this.state.persons[i]}
                onClick={() => this.deleteUser(person)}
              >
                X
              </button>
            </td>
          </tr>
        );
      }

      for (let i = 0; i < personRows.length; i++) {
        if (this.state.persons[i].paid === true) {
          paid++;
        }
      }
      for (let i = 0; i < personRows.length; i++) {
        if (this.state.persons[i].arrived === true) {
          arrived++;
        }
      }
      for (let i = 0; i < personRows.length; i++) {
        if (this.state.persons[i].foodTicket === true) {
          food++;
        }
      }

      let numberSigned = <h5>Antall påmeldte: {personRows.length} </h5>;
      let numberPaid = <h5>Betalt: {paid} </h5>;
      let numberFood = <h5>Matbillett: {food}</h5>;
      let numberArrived = <h5>Ankommet: {arrived}</h5>;

      const printRows = [];
      printRows.push(
        <div key={printRows.length} className="seatNotes">
          <h2>Plasslapper</h2>
          <br />
          <br />
          <br />
          <h4>{this.state.persons.length} deltakere</h4>
        </div>
      );
      for (let i = 0; i < this.state.persons.length; i++) {
        printRows.push(
          <div key={i + this.state.persons[i].code} className="seatNotes">
            <div className="printNewPage"></div>
            <br />
            <br />
            <br />
            <br />
            <h1>GAMERLAN </h1>
            <br />
            <br />
            <br />
            <h2>
              {this.state.persons[i].firstName +
                " " +
                this.state.persons[i].lastName}
              <br />
              <br />
            </h2>
            <br />
            <br />
            <br />
            <h4>Rad: {this.state.persons[i].rowNum}</h4>
            <br />
            <h4>Plass: {this.state.persons[i].seatNum}</h4>
          </div>
        );
      }

      const printListRows = [];
      for (let i = 0; i < this.state.persons.length; i++) {
        printListRows.push(
          <tr key={i + this.state.persons[i].code}>
            <td>{this.state.persons[i].arrived ? "X" : ""}</td>
            <td>{this.state.persons[i].code}</td>
            <td>{this.state.persons[i].paid ? "X" : ""}</td>
            <td>{this.state.persons[i].foodTicket ? "X" : ""}</td>
            <td>
              R{this.state.persons[i].rowNum}-S{this.state.persons[i].seatNum}
            </td>
            <td>
              {this.state.persons[i].firstName} {this.state.persons[i].lastName}{" "}
              - {this.state.persons[i].phone}
            </td>
            <td> {this.state.persons[i].age}</td>
          </tr>
        );
      }
      for (let i = 0; i < 35; i++) {
        printListRows.push(
          <tr key={i}>
            <td> </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        );
      }

      return (
        <div className="SignupList">
          {this.state.printNotes === false && this.state.printList === false && (
            <div>
              <h1>Brukerliste</h1>

              {numberSigned}
              {numberPaid}
              {numberFood}
              {numberArrived}
              <p>
                Sist oppdatert:{" "}
                {this.state.updated.toLocaleString("en-GB", {
                  timeZone: "UTC"
                })}
              </p>
              <br />
              <button
                className={
                  "btn btno edit printHide " +
                  (this.state.editMode ? "btn-info" : "btn-danger")
                }
                onClick={this.setEditMode}
              >
                {this.state.editMode ? "Lås" : "Rediger"}
              </button>
              <button
                className="btn btno btn-success edit printHide "
                onClick={() => this.getPersons()}
              >
                Oppdater
              </button>
              <button
                className="btn btno btn-info edit printHide "
                onClick={this.seatList}
              >
                Skriv ut
              </button>
              <button
                className="btn btno btn-info edit printHide "
                onClick={this.seatNotes}
              >
                Plasslapper
              </button>
              <button
                className="btn btno btn-info edit printHide "
                onClick={this.addUser}
              >
                Legg til bruker
              </button>
              <br />
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Kode</th>
                    <th>Påmeldt</th>
                    <th>Betalt</th>
                    <th>Ankommet</th>
                    <th>Rad</th>
                    <th>Plass</th>
                    <th>Fornavn</th>
                    <th>Etternavn</th>
                    <th>Epost</th>
                    <th>Alder</th>
                    <th>Matbillett</th>
                    <th>Telefon</th>
                    <th className="printHide">Handlinger</th>
                  </tr>
                </thead>
                <tbody>{personRows}</tbody>
              </table>
            </div>
          )}
          {this.state.printNotes && <div className="print">{printRows}</div>}
          {this.state.printList && (
            <div className="printList">
              {numberSigned}
              {numberPaid}
              {numberFood}
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Kommet</th>
                    <th>Kode</th>
                    <th>Betalt</th>
                    <th>Matbillett</th>
                    <th>Plass</th>
                    <th>Deltaker</th>
                    <th>Alder</th>
                  </tr>
                </thead>
                <tbody>{printListRows}</tbody>
              </table>
            </div>
          )}
          {this.state.showAddUserModal === true && (
            <AddUserModal
              checkAuthentication={this.props.checkAuthentication}
              addUser={this.addUser}
              onUserAdded={this.getPersons}
            />
          )}
          <MoveUserModal
            show={this.state.showMoveUserModal}
            person={this.state.selectedUserForMove}
            onClose={this.closeMoveModal}
            onMoveSuccess={this.onMoveSuccess}
          />
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/Components/Admin/SignupList.js